import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { color } from '../../app/theme';

const styles = makeStyles(
  () => ({
    button: {
      display: 'flex',
      alignItems: 'center',
      color: color.$2,
      textDecoration: 'underline',
      fontSize: '13px',
      lineHeight: 1,
      cursor: 'pointer',
    },
  }),
  'TextButton',
);

const TextButton = props => {
  const { isLoading, text, onClick, ...otherProps } = props;
  const classes = styles();

  return (
    <div
      className={classes.button}
      onClick={() => {
        if (!isLoading) {
          if (onClick) onClick();
        }
      }}
      {...otherProps}
    >
      {isLoading && (
        <CircularProgress style={{ width: 20, height: 20, marginRight: 4 }} />
      )}
      {text}
    </div>
  );
};

export default TextButton;
